export default [
  {
    path: '/ai-banners',
    component: () => import('./views/Index'),
    name: 'ai_banner',
    redirect: { name: 'ai_banner-list' },
    children: [
      {
        path: '',
        name: 'ai_banner-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'content',
        },
      },
      {
        path: ':id',
        name: 'ai_banner-detail',
        component: () => import('./views/Detail'),
        meta: {
          resource: 'content',
        },
      },
    ],
  },
]
